import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { Tree } from "@dreamhub/designsystem/icons";
import { IconButton, IconButtonVariant } from "@/components/ui/icon-button";

interface DrillDownButtonProps {
  variant?: IconButtonVariant;
  className?: string;
  idContext?: string;
  onClick?: () => void;
  disabled?: boolean;
  tooltip: string;
  disabledTooltip: string;
}

const DrillDownButton = ({
  variant = "iconNoBg",
  className = "size-8",
  idContext,
  onClick,
  disabled = false,
  tooltip,
  disabledTooltip
}: DrillDownButtonProps) => {
  const buttonId = idContext ? `drilldown-${idContext}` : "drilldown";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton
          variant={variant}
          id={buttonId}
          className={className}
          onClick={onClick}
          disabled={disabled}
          iconColor="secondary"
        >
          <Tree />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent>{disabled ? disabledTooltip : tooltip}</TooltipContent>
    </Tooltip>
  );
};

export default DrillDownButton;
